function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "HomeMenu-icon-Homework",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  transform: "translate(19.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M41.024,56.346 C41.0152027,57.5150749 40.0641068,58.4576828 38.895,58.4560022 L2.112,58.291 C0.942372063,58.2827519 -0.00112890053,57.3316565 -1.01199125e-06,56.162 L0.237,7.394 C0.245797344,6.22492505 1.19689316,5.28231717 2.366,5.28399775 L39.15,5.449 C40.3190749,5.45779734 41.2616828,6.40889316 41.2600022,7.578 L41.024,56.346 Z",
  id: "Trazado_492",
  fill: "#A2A9B3",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.392,56.597 L5.342,56.597 C4.21207735,56.5642983 3.31957745,55.6271734 3.342,54.497 L3.342,11.439 C3.31957745,10.3088266 4.21207735,9.37170174 5.342,9.339 L37.615,9.339 C38.7449226,9.37170174 39.6374226,10.3088266 39.615,11.439 L39.615,49.047 C37.209,51.5656667 34.8013333,54.0823333 32.392,56.597 Z",
  id: "Trazado_493",
  fill: "#5A6572",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.685,55.606 L4.636,55.606 C3.50607735,55.5732983 2.61357745,54.6361734 2.636,53.506 L2.636,10.448 C2.61357745,9.31782664 3.50607735,8.38070174 4.636,8.348 L36.909,8.348 C38.0389226,8.38070174 38.9314226,9.31782664 38.909,10.448 L38.909,48.056 C36.5016667,50.574 34.0936667,53.0906667 31.685,55.606 Z",
  id: "Trazado_494",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36.122,51.035 C34.6626667,52.559 33.203,54.0826667 31.743,55.606 L31.743,50.258 C31.7183483,49.1045737 32.6287895,48.1472485 33.782,48.114 L38.913,48.114 C37.9856667,49.09 37.0553333,50.0636667 36.122,51.035 Z",
  id: "Trazado_495",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.874,5.591 L9.644,5.591 C8.93024857,6.17442736 8.51437469,7.0461489 8.51,7.968 C8.502,9.674 8.5,10.219 8.5,10.219 L34.109,10.334 C34.109,10.334 34.109,9.791 34.1190457,8.083 C34.1243357,7.10151156 33.6620166,6.17613062 32.874,5.591 Z",
  id: "Trazado_496",
  fill: "#5A6572",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.476,4.556 C24.436,4.529 24.195,2.848 24.113,2.551 C23.7027024,1.05403249 22.3481691,0.0116250807 20.7960479,-0.00162501815 C19.2439266,-0.014875117 17.8717945,1.00425539 17.436,2.494 C17.348,2.794 16.836,4.494 11.048,4.467 L11.048,4.467 C10.2282136,4.46354493 9.44063185,4.78589397 8.85851735,5.36313251 C8.27640286,5.94037105 7.94744057,6.72521358 7.944,7.545 C7.936,9.251 7.934,9.796 7.934,9.796 L33.543,9.911 C33.543,9.911 33.543,9.368 33.5530366,7.66 C33.556987,6.84022581 33.2349468,6.05248738 32.6578098,5.47028604 C32.0806727,4.88808471 31.2957777,4.55917496 30.476,4.556 Z M20.78,0.82 C21.52848,0.825529783 22.13092,1.43647859 22.1259523,2.18496258 C22.1209846,2.93344657 21.5104883,3.53634511 20.7620008,3.5319635 C20.0135133,3.5275339 19.4101565,2.91749061 19.4139817,2.169 C19.4158494,1.80884186 19.5609045,1.46421537 19.8171678,1.21114135 C20.073431,0.958067325 20.4198469,0.817339183 20.78,0.82 Z",
  id: "Trazado_497",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.94,8.557 C7.94,9.474 7.935,9.796 7.935,9.796 L33.544,9.911 C33.544,9.911 33.544,9.59 33.549,8.672 L7.94,8.557 Z",
  id: "Trazado_498",
  fill: "#DEEDFC",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_362",
  transform: "translate(19.419000, 0.820000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.349,2.71101812 C1.89753167,2.71382629 2.39373597,2.38589496 2.60617079,1.88016141 C2.81860561,1.37442785 2.70542146,0.79052117 2.31941025,0.400790064 C1.93339905,0.011058959 1.3506047,-0.107719851 0.842857076,0.0998550436 C0.335109454,0.307429939 0.00243444464,0.800466448 -9.49846101e-06,1.349 C-0.00277012856,2.09728677 0.600721073,2.70659368 1.349,2.71101812 L1.349,2.71101812 Z",
  id: "Trazado_499"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_363",
  transform: "translate(19.459000, 2.361000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.023,0.119 C0.71424993,0.321001879 0.317516678,0.32992159 0,0.142 C0.14966102,0.743850952 0.688826183,1.16727478 1.309,1.17 C1.52296514,1.1715412 1.73418841,1.12182144 1.925,1.025 C1.83597659,0.846809098 1.73193369,0.676526662 1.614,0.516 C1.51748414,0.358929018 1.39626003,0.218457628 1.255,0.1 C1.192,0.058 1.195,0.02 1.207,-1.77635684e-15 C1.14857404,0.0439910291 1.08708469,0.083758603 1.023,0.119 L1.023,0.119 Z",
  id: "Trazado_500"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_364",
  transform: "translate(29.650000, 13.270000)",
  fill: "#A2A9B3",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,4.681 L0,0 L4.683,0 L4.683,4.683 L0,4.683 L0,4.681 Z M4.025,4.025 L4.025,0.656 L0.657,0.656 L0.657,4.02 L4.025,4.02 L4.025,4.025 Z",
  id: "Trazado_501"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.502,4.499 L0.182,4.499 L0.182,0.182 L4.502,0.182 L4.502,4.499 Z M0.477,4.207 L4.21,4.207 L4.21,0.474 L0.477,0.474 L0.477,4.207 Z",
  id: "Trazado_502"
})), /*#__PURE__*/React.createElement("path", {
  d: "M20.165,13.956 C20.154146,14.2470395 19.9100848,14.4745617 19.619,14.465 L7.702,14.465 C7.4109152,14.4745617 7.16685403,14.2470395 7.156,13.956 L7.156,13.956 C7.16685403,13.6649605 7.4109152,13.4374383 7.702,13.447 L19.619,13.447 C19.9102935,13.4368811 20.1546872,13.6647133 20.165,13.956 L20.165,13.956 Z",
  id: "Trazado_503",
  fill: "#A2A9B3",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.509,15.406 C26.5019409,15.6013123 26.338342,15.7541834 26.143,15.748 L7.552,15.748 C7.35665801,15.7541834 7.19305911,15.6013123 7.186,15.406 L7.186,15.406 C7.19305911,15.2106877 7.35665801,15.0578166 7.552,15.064 L26.146,15.064 C26.3417265,15.0572528 26.5059446,15.2102844 26.513,15.406 L26.509,15.406 Z",
  id: "Trazado_504",
  fill: "#BCAFAF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.509,16.6039997 C26.5019409,16.7993123 26.338342,16.9521834 26.143,16.946 L7.552,16.946 C7.35665801,16.9521834 7.19305911,16.7993123 7.186,16.6039997 L7.186,16.6039997 C7.19305911,16.4086877 7.35665801,16.2558166 7.552,16.262 L26.146,16.262 C26.3415184,16.2558082 26.5054052,16.4085311 26.513,16.6039997 L26.509,16.6039997 Z",
  id: "Trazado_505",
  fill: "#BCAFAF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.117,17.7909997 C17.1099409,17.9863123 16.946342,18.1391834 16.751,18.133 L7.551,18.133 C7.35565801,18.1391834 7.19205911,17.9863123 7.185,17.7909997 L7.185,17.7909997 C7.19205911,17.5956877 7.35565801,17.4428166 7.551,17.449 L16.751,17.449 C16.9465184,17.4428082 17.1104052,17.5955311 17.118,17.7909997 L17.117,17.7909997 Z",
  id: "Trazado_506",
  fill: "#BCAFAF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_365",
  transform: "translate(29.650000, 21.638000)",
  fill: "#A2A9B3",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,4.683 L0,0 L4.683,0 L4.683,4.683 L0,4.683 Z M4.025,4.025 L4.025,0.658 L0.657,0.658 L0.657,4.025 L4.025,4.025 Z",
  id: "Trazado_507"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.502,4.5 L0.182,4.5 L0.182,0.184 L4.502,0.184 L4.502,4.5 Z M0.477,4.209 L4.21,4.209 L4.21,0.474 L0.477,0.474 L0.477,4.209 Z",
  id: "Trazado_508"
})), /*#__PURE__*/React.createElement("path", {
  d: "M20.165,22.324 C20.154146,22.6150395 19.9100848,22.8425617 19.619,22.833 L7.702,22.833 C7.4109152,22.8425617 7.16685403,22.6150395 7.156,22.324 L7.156,22.324 C7.16685403,22.0329605 7.4109152,21.8054383 7.702,21.815 L19.619,21.815 C19.9100848,21.8054383 20.154146,22.0329605 20.165,22.324 Z",
  id: "Trazado_509",
  fill: "#A2A9B3",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.509,23.7739997 C26.5019409,23.9693123 26.338342,24.1221834 26.143,24.116 L7.552,24.116 C7.35665801,24.1221834 7.19305911,23.9693123 7.186,23.7739997 L7.186,23.7739997 C7.19305911,23.5786877 7.35665801,23.4258166 7.552,23.432 L26.146,23.432 C26.3415184,23.4258082 26.5054052,23.5785311 26.513,23.7739997 L26.509,23.7739997 Z",
  id: "Trazado_510",
  fill: "#BCAFAF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.509,24.973 C26.5019409,25.1683123 26.338342,25.3211834 26.143,25.315 L7.552,25.315 C7.35665801,25.3211834 7.19305911,25.1683123 7.186,24.973 L7.186,24.973 C7.19305911,24.7776877 7.35665801,24.6248166 7.552,24.631 L26.146,24.631 C26.3417265,24.6242528 26.5059446,24.7772844 26.513,24.973 L26.509,24.973 Z",
  id: "Trazado_511",
  fill: "#BCAFAF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.117,26.161 C17.1099409,26.3563123 16.946342,26.5091834 16.751,26.503 L7.551,26.503 C7.35565801,26.5091834 7.19205911,26.3563123 7.185,26.161 L7.185,26.161 C7.18812549,26.0671805 7.22849091,25.9784697 7.29717231,25.9144797 C7.36585372,25.8504896 7.45719409,25.8164909 7.551,25.82 L16.751,25.82 C16.8449754,25.8162181 16.9365745,25.8500947 17.0054747,25.9141137 C17.074375,25.9781327 17.1148789,26.0670003 17.118,26.161 L17.117,26.161 Z",
  id: "Trazado_512",
  fill: "#BCAFAF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_366",
  transform: "translate(29.650000, 29.924000)",
  fill: "#A2A9B3",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,4.683 L0,0 L4.683,0 L4.683,4.683 L0,4.683 Z M4.025,4.027 L4.025,0.659 L0.657,0.659 L0.657,4.027 L4.025,4.027 Z",
  id: "Trazado_513"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.502,4.501 L0.182,4.501 L0.182,0.185 L4.502,0.185 L4.502,4.501 Z M0.477,4.209 L4.21,4.209 L4.21,0.474 L0.477,0.474 L0.477,4.209 Z",
  id: "Trazado_514"
})), /*#__PURE__*/React.createElement("path", {
  d: "M20.165,30.611 C20.154146,30.9020395 19.9100848,31.1295617 19.619,31.12 L7.702,31.12 C7.4109152,31.1295617 7.16685403,30.9020395 7.156,30.611 L7.156,30.611 C7.16685403,30.3199605 7.4109152,30.0924383 7.702,30.102 L19.619,30.102 C19.9102935,30.0918811 20.1546872,30.3197133 20.165,30.611 L20.165,30.611 Z",
  id: "Trazado_515",
  fill: "#A2A9B3",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.509,32.062 C26.5019409,32.2573123 26.338342,32.4101834 26.143,32.404 L7.552,32.404 C7.35665801,32.4101834 7.19305911,32.2573123 7.186,32.062 L7.186,32.062 C7.19305911,31.8666877 7.35665801,31.7138166 7.552,31.72 L26.146,31.72 C26.3417265,31.7132528 26.5059446,31.8662844 26.513,32.062 L26.509,32.062 Z",
  id: "Trazado_516",
  fill: "#BCAFAF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.509,33.257 C26.5019409,33.4523123 26.338342,33.6051834 26.143,33.599 L7.552,33.599 C7.35665801,33.6051834 7.19305911,33.4523123 7.186,33.257 L7.186,33.257 C7.19305911,33.0616877 7.35665801,32.9088166 7.552,32.915 L26.146,32.915 C26.3417265,32.9082528 26.5059446,33.0612844 26.513,33.257 L26.509,33.257 Z",
  id: "Trazado_517",
  fill: "#BCAFAF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.117,34.447 C17.1099409,34.6423123 16.946342,34.7951834 16.751,34.789 L7.551,34.789 C7.35565801,34.7951834 7.19205911,34.6423123 7.185,34.447 L7.185,34.447 C7.18812549,34.3531805 7.22849091,34.2644697 7.29717231,34.2004797 C7.36585372,34.1364896 7.45719409,34.1024909 7.551,34.106 L16.751,34.106 C16.8449037,34.1024882 16.9363507,34.1364562 17.0051908,34.2004193 C17.0740309,34.2643825 17.1146148,34.3530916 17.118,34.447 L17.117,34.447 Z",
  id: "Trazado_518",
  fill: "#BCAFAF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_367",
  transform: "translate(29.650000, 38.054000)",
  fill: "#A2A9B3",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,4.683 L0,0 L4.683,0 L4.683,4.683 L0,4.683 Z M4.025,4.025 L4.025,0.658 L0.657,0.658 L0.657,4.025 L4.025,4.025 Z",
  id: "Trazado_519"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.502,4.5 L0.182,4.5 L0.182,0.184 L4.502,0.184 L4.502,4.5 Z M0.477,4.209 L4.21,4.209 L4.21,0.474 L0.477,0.474 L0.477,4.209 Z",
  id: "Trazado_520"
})), /*#__PURE__*/React.createElement("path", {
  d: "M20.165,38.741 C20.154146,39.0320395 19.9100848,39.2595617 19.619,39.25 L7.702,39.25 C7.4109152,39.2595617 7.16685403,39.0320395 7.156,38.741 L7.156,38.741 C7.16685403,38.4499605 7.4109152,38.2224383 7.702,38.232 L19.619,38.232 C19.9100848,38.2224383 20.154146,38.4499605 20.165,38.741 L20.165,38.741 Z",
  id: "Trazado_521",
  fill: "#A2A9B3",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.509,40.1909997 C26.5019409,40.3863123 26.338342,40.5391834 26.143,40.533 L7.552,40.533 C7.35665801,40.5391834 7.19305911,40.3863123 7.186,40.1909997 L7.186,40.1909997 C7.19305911,39.9956877 7.35665801,39.8428166 7.552,39.849 L26.146,39.849 C26.3415184,39.8428082 26.5054052,39.9955311 26.513,40.1909997 L26.509,40.1909997 Z",
  id: "Trazado_522",
  fill: "#BCAFAF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.509,41.388 C26.5019409,41.5833123 26.338342,41.7361834 26.143,41.73 L7.552,41.73 C7.35665801,41.7361834 7.19305911,41.5833123 7.186,41.388 L7.186,41.388 C7.19305911,41.1926877 7.35665801,41.0398166 7.552,41.046 L26.146,41.046 C26.3413116,41.0403577 26.5048717,41.1927761 26.513,41.388 L26.509,41.388 Z",
  id: "Trazado_523",
  fill: "#BCAFAF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.117,42.578 C17.1099409,42.7733123 16.946342,42.9261834 16.751,42.92 L7.551,42.92 C7.35565801,42.9261834 7.19205911,42.7733123 7.185,42.578 L7.185,42.578 C7.18812549,42.4841805 7.22849091,42.3954697 7.29717231,42.3314797 C7.36585372,42.2674896 7.45719409,42.2334909 7.551,42.237 L16.751,42.237 C16.8449754,42.2332181 16.9365745,42.2670947 17.0054747,42.3311137 C17.074375,42.3951327 17.1148789,42.4840003 17.118,42.578 L17.117,42.578 Z",
  id: "Trazado_524",
  fill: "#BCAFAF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_369",
  transform: "translate(7.404000, 41.388000)",
  fill: "#60C967",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_368"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.568,2.953 C11.3267959,3.29985433 11.105441,3.66009849 10.905,4.032 C11.6662309,5.62109302 11.5627324,7.48897488 10.6305985,8.98423925 C9.69846455,10.4795036 8.06693859,11.3948274 6.305,11.411 L6.262,11.411 C3.41469597,11.4242548 1.09575483,9.12680403 1.0825,6.2795 C1.06924517,3.43219597 3.36669597,1.11325483 6.214,1.1 L6.257,1.1 C7.24780879,1.09960605 8.21753182,1.3861467 9.049,1.925 C9.26614596,1.62450024 9.50512549,1.34039869 9.764,1.075 C8.72998494,0.372108543 7.50829683,-0.00317899271 6.258,-0.00200276941 L6.205,-0.00200276941 C2.75257381,0.0342761243 -0.0199859438,2.85647364 0.005,6.309 L0.005,6.309 C0.0411456533,9.74069905 2.83111316,12.5048088 6.263,12.509 L6.316,12.509 C8.5793242,12.4914122 10.6564599,11.2521072 11.7468968,9.26870277 C12.8373336,7.28529831 12.770824,4.8674592 11.573,2.947 L11.568,2.953 Z",
  id: "Trazado_525"
})), /*#__PURE__*/React.createElement("path", {
  d: "M6.585,9.158 C6.50454235,9.17312071 6.42286596,9.18081971 6.341,9.181 C6.04291016,9.21309884 5.7442941,9.12531291 5.511,8.937 L2.491,6.328 C2.33507281,6.19195859 2.24450772,5.99591609 2.242,5.789 C2.2440206,5.45295916 2.38051174,5.13171882 2.621,4.897 C2.75356313,4.75605547 2.9258502,4.65875164 3.115,4.618 C3.4022134,4.57475286 3.69303041,4.66922208 3.9,4.873 L6.209,6.836 L8.723,3.32 C8.73,3.307 10.307,1.093 11.009,0.961 C11.0756005,0.946954565 11.1447781,0.951451107 11.209,0.974 C11.3092738,1.01166029 11.3864517,1.09363866 11.418,1.196 C11.618,1.796 10.446,3.732 10.435,3.752 L7.365,8.659 C7.18596406,8.92515169 6.90535,9.10595972 6.589,9.159 L6.585,9.158 Z",
  id: "Trazado_526"
}))));
function SvgHomeMenuIconHomework(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "69px",
    viewBox: "0 0 80 69",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HomeMenu-icon-Homework") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMenuIconHomework);
export default __webpack_public_path__ + "static/media/HomeMenu-icon-Homework.dd7957f53b668f6853a25fa21589496c.svg";
export { ForwardRef as ReactComponent };